import { SiTwitch, SiYoutube, SiKick } from "react-icons/si";
import { Video } from "lucide-react";

export default function PlatformIcon({ platform, className = "w-4 h-4" }) {
  const p = (platform || "").toLowerCase();
  if (p === "twitch") return <SiTwitch className={className} style={{ color: "#B9D2ED" }} aria-label="Twitch" />;
  if (p === "youtube") return <SiYoutube className={className} style={{ color: "#ff6b6b" }} aria-label="YouTube" />;
  if (p === "kick") return <SiKick className={className} style={{ color: "#53fc18" }} aria-label="Kick" />;
  return <Video className={className} style={{ color: "#A3ADBA" }} aria-label={platform || "Other platform"} />;
}
